import { TThunkAction } from '../../types/redux';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { EOpenNewAnswerForm } from './openFormActionsTypes';
import { getNewAnswerFormStep } from '../../selectors/newAnswer';
import { ENewAnswerModalStep } from '../../types/newAnswer';
import { setNewAnswerFormStep } from './stepActionsTypes';
import { clearNewAnswerFormAction } from './newAnswearAction';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { TAnswerTarget } from '../../types/answers';
import { getNewbuildingRating } from '../../selectors/newbuildingInfo';
import { TPageExtra, trackNewAnswerClick } from './tracking/trackNewAnswerClick';
import { getIsQuestionTab } from '../../selectors/tabs';

export type TSetNewAnswerFormOpenPayload = {
  id: string;
  type: TAnswerTarget;
};
export type TSetNewAnswerFormOpen = ITypedReduxAction<EOpenNewAnswerForm.Open, TSetNewAnswerFormOpenPayload>;
export const setNewAnswerFormOpenAction: (payload: TSetNewAnswerFormOpenPayload) => TSetNewAnswerFormOpen =
  actionGenerator<EOpenNewAnswerForm.Open, TSetNewAnswerFormOpenPayload>(EOpenNewAnswerForm.Open);
export const setNewAnswerFormCloseAction = actionGenerator<EOpenNewAnswerForm.Close>(EOpenNewAnswerForm.Close);

export function setNewAnswerFormOpen(payload: TSetNewAnswerFormOpenPayload): TThunkAction<Promise<void>> {
  return async (dispatch, getState, context) => {
    const siteType = context.custom.deviceType;
    const state = getState();
    const isQuestion = getIsQuestionTab(state);
    let type: string = payload.type;

    if (type === 'answer' && isQuestion) {
      type = 'answer_to_question';
    }

    const rating = getNewbuildingRating(state);

    const extra: TPageExtra = {
      rating,
      type,
    };

    if (type === 'question') {
      extra.question_id = payload.id;
    } else {
      extra.review_id = payload.id;
    }

    const page = {
      offerType: 'JK',
      pageType: 'ReviewsJK',
      siteType,
      extra,
    };

    trackNewAnswerClick(page);

    dispatch(setNewAnswerFormOpenAction(payload));
  };
}

export function setNewAnswerFormClose(): TThunkAction<Promise<void>> {
  return async (dispatch, getState) => {
    const state = getState();
    const newAnswerStep = getNewAnswerFormStep(state);

    if (newAnswerStep === ENewAnswerModalStep.Success) {
      dispatch(clearNewAnswerFormAction());
    }

    dispatch(setNewAnswerFormStep(ENewAnswerModalStep.Answer));
    dispatch(setNewAnswerFormCloseAction());
  };
}
